/* eslint-disable */
import * as t from 'io-ts';
import { BasicResponseStructure } from './resourceLinkCodec';

export const tag = t.type({
    id: t.string,
    type: t.string,
    name: t.string,
    account_id: t.string,
});

export const apiTagCodec = t.type({
    items: t.array(tag),
});

export type ApiResponseTags = BasicResponseStructure & t.TypeOf<typeof apiTagCodec>;
export type ApiResponseTag = t.TypeOf<typeof tag>;
